module.exports = __webpack_public_path__ + "static/culturevelo-c47524adaafcb36becaeda0e3283a4f7.png";